// getters.js

export default {
    getFields(state){
        return state.fields
    },
    getMessages(state){
        return state.messages
    },
    getCurrantPage(state){
        return state.currentPage
    },
    getLastPage(state){
        return state.lasPage
    },
    getIsSearchDone(state){
        return state.isSearchDone
    },
    getLastDevicesMessages(state){
        return state.lastDevicesMessages
    },
    getSelectedFields(state) {
        return state.selectedFields || []
    }
};
